
   
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { JwtService } from '@app/core/services/jwt.service';
import { first, Observable } from 'rxjs';
import { TokenAuthService as AuthService} from '../../../shared/token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private _jwt:JwtService)
  {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // Skip validation for super-admin routes (they have their own auth)
      if (state.url.startsWith('/super-admin')) {
        return true;
      }

      this._jwt.validateToken().pipe(first()).subscribe(({ data }: any)=> {
        if(data['authenticated'] != true){
          return this.router.navigate(['login']);
        }
      });

      return true;
  }
  
}